﻿export class FileUploadPending {
    static eventName() { return 'FileUploadPending' }
    eventName = FileUploadPending.eventName;
}